@for (pc of labPCs; track pc) {
  <button
    class="btn btn-lg btn-secondary"
  (click)="click(pc)" >INF{{pc}}</button>
}
